import React from "react";
import { connect } from "react-redux";
import LoadingOverlay from "../components/overlays/LoadingOverlay";

const Home = () => {

  return <>
    <div className="w-100 h-100">
      <LoadingOverlay show={true} />
    </div>
  </>
};

const mapState = (state) => {
  const pageTitle = state.AppReducer.pageTitle;
  return { pageTitle };
};

const mapDispatch = dispatch => ({});

export default connect(mapState, mapDispatch)(Home);
